module.exports = __webpack_public_path__ + "img/info-outline.268a6693.svg";